<template>
  <div>
    <headers />
    <div class="page-content">
      <sidebar-menu ref="sidebar"></sidebar-menu>
      <div class="common-content"
           :class="showSidebarMenuMini?'margin-78': 'margin-221'">
        <router-view />
      </div>
    </div>
    <!-- <lesson-NoReg></lesson-NoReg>去掉轮询打卡消息弹层 -->
    <notice-modal></notice-modal>
    <!-- <teacher-PaypalModify></teacher-PaypalModify> -->
    <system-msg-modal></system-msg-modal>
    <right-alert></right-alert>
    <binding-phone></binding-phone>
    <level ref="levels"
           :levelData="levelData" />
    <chatBox ref="chatBoxs"
           :chatBoxData="chatBoxData" />
     <report ref="reports"
           :reportData="reportData" />      
    <points ref="points"
            :pointsData="pointsData" />
    <growth-values ref="values"
                   :growthValues="growthValues" />
    <covertCash ref="cashs"
                :cashData="cashData" />
    <email ref="email"
           :emailData="emailData" />
    <enrolment ref="enrolment"
               :enrolmentData="enrolmentData" />
    <!-- <lottery-preheat v-if="this.$route.path != '/myReferrals/lottery'"></lottery-preheat> -->
    <tesol-dialog></tesol-dialog>
    <client-download-dialog :clientDownload="clientDownload" />
    <skype-id-dialog :skypeIdDialogs="skypeIdDialogs"></skype-id-dialog>
    <!-- 左侧全局图标按钮 -->
    <div class="overall-btns"
         v-intro="'Floating action button area'"
         v-intro-position="'bottom-middle-aligned'"
         v-intro-step="firstLogin? '2': ''"
         v-intro-highlight-class="'blue-grey darken-4 fix-hint'"
         v-intro-disable-interaction="false">
      <!-- <app-flow v-if="this.$store.state.user.isShowAppFloatingIcon" /> -->
      <feedback-dialog :feedbackData="feedbackData"></feedback-dialog>
      <lesson-reminder v-if="this.$route.name != 'releaseTime'"></lesson-reminder>
      <didi-dialog/>
      <referral-share v-if="!this.$store.state.user.limitRefferal" />
      <moodle />
      <public-class />
      <imiframe ref="imiframe"></imiframe>
    </div>
    <!-- 右侧图标 -->
    <div class="overall-btns-right">
      <growth-center-entry v-if="this.$store.state.user.isGrowthSystemTestGroup && this.$route.path.indexOf('growthCenter')<0 && this.$route.path.indexOf('home')<0" />
    </div>
    <imLinkUI ref='imLinkUI'></imLinkUI>
    <christmas-dialog></christmas-dialog>
    <course-attendance-dialog></course-attendance-dialog>

    <v-dialog lazy
              v-model="refreshDialog"
              max-width="400"
              @keydown.esc="cancel"
              style="{ zIndex: 999 }"
              :persistent="true"
              content-class="custom-dialog refresh-dialog">
      <v-card>
        <v-toolbar color="white"
                   dense
                   flat>
          <!-- <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark flat @click="cancel">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items> -->

        </v-toolbar>
        <div>
          <p class="custom-icon">
            <v-icon color="#FF9991">lock</v-icon>
          </p>
          <v-card-text class='align-center pb-0 title pink-text-light'>{{ message1 }}</v-card-text>
          <v-card-text class='align-center blue-title'>{{ message2 }}</v-card-text>

          <div class="custom-footer">
            <v-btn class="text-none pink-button dialog-submit"
                   @click.native="toRefresh"
                   round>Refresh</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="reminder.dialog"
              max-width="940"
              style="{ zIndex: 999; }"
              :persistent="true">
      <v-card class="px-3 pb-3 pt-0"
              style="color: #32397A;line-height: 22px;">
        <v-card-title class="headline text-xs-center font-weight-bold"
                      primary-title>
          <v-spacer></v-spacer>
          WARNING AND IMPORTANT REMINDER
          <v-spacer></v-spacer>

          <v-progress-circular :rotate="-90"
                               :size="45"
                               :width="3"
                               :value="reminder.progress"
                               class="body-2 font-weight-bold red--text">
            {{reminder.seconds}}s
          </v-progress-circular>
        </v-card-title>
        <v-card-text>
          <p>Please be warned that while you are at work and accessing ClassIn, Tutor Page, and company’s system and network, your browsing behavior, sites being visited and videos being watched are monitored and captured by the company.These class recordings are for quality check purpose. You are obliged to perform as a professional teacher. Your personal life should not get involved. And the company would not use it for other purpose. </p>
          <p style="color:#EE344C;">
            During teaching hours, all websites not related to teaching must be closed. You are prohibited from:<br>
            <i class="material-icons"
               style="vertical-align: middle;font-size: 20px;">remove_circle</i> Listening, watching, or viewing pornographic sites and adult materials.<br>
            <i class="material-icons"
               style="vertical-align: middle;font-size: 20px;">remove_circle</i> Discussing, engaging, or viewing sites and materials related to drugs, liquor, gambling, violence, pornography, race, religion, and politics with the students.
          </p>
          <p>
            Commission of the above acts and similar circumstances that are unacceptable in a teaching and working situation shall immediately entitle the company to:<br>
            a.) Terminate your services; and/or<br>
            b.) File suit in the appropriate court for damages; and/or<br>
            c.) File suit in the appropriate court for any and all causes of action available to it.
          </p>
          <p>
            <span class="font-weight-bold">User compliance</span><br>
            I understand and will abide by this Warning and Reminder. I further understand that should I commit any violation as above-mentioned, my services may outrightly be terminated, and/or appropriate legal action may be taken.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn color="#EE344C"
                   class="text-none white--text"
                   style="height: 30px;border-radius: 5px;box-shadow: none;"
                   :disabled="reminder.seconds!==0"
                   @click="agreeProtocol">I Agree</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {
  mapGetters
} from 'vuex'
import sidebarMenu from './sidebarMenu'
import headers from './headers.vue'
// import lessonNoReg from '@/components/dialogs/lessonNoReg'
import noticeModal from '@/components/dialogs/noticeModal'
import systemMsgModal from '@/components/dialogs/systemMsgModal'
import rightAlert from '@/components/dialogs/rightAlert'
// import teacherPaypalModify from '@/components/dialogs/teacherPaypalModify'

import level from '../../components/dialogs/level'
import chatBox from '../../components/dialogs/chatBox'
import report from '../../components/dialogs/testReport'
import points from '../../components/dialogs/points'
import covertCash from '../../components/dialogs/covertCash'
import growthValues from '../../components/dialogs/growthValues'
// import password from '../../components/dialogs/password'
import email from '../../components/dialogs/changeEmail'

import bindingPhone from '../../components/dialogs/bindingPhone'

import enrolment from '../../components/dialogs/enrolment'

const imiframe = () => import('@/components/imiframe/imiframe')//引入IM组件，必须要懒加载
import imLinkUI from '@/components/imiframe/imLinkUI'
// import lotteryPreheat from '@/components/lotteryPreheat' //百万推荐官预热组件

import feedbackDialog from '@/components/feedbackDialog'//反馈按钮 

import lessonReminder from '@/components/lessonReminder'//自主放课提醒按钮
import didiDialog from '@/components/didiDialog'//didi提醒弹层

import referralShare from '@/components/referralShare'//推荐链接分享
import moodle from '@/components/moodle'//moodle平台消息
import appFlow from '@/components/appFlow'//自主放课提醒按钮
import publicClass from '@/components/publicClass'//
import tesolDialog from '@/components/TESOLRegistrationDialog'//
import clientDownloadDialog from '@/components/dialogs/clientDownloadDialog'
import christmasDialog from '@/components/specialEvents/christmas'
import { getAgoraCoursewarePreloadPageUrl } from '@/api/classtable.js'
import courseAttendanceDialog from '@/components/dialogs/courseAttendanceDialog'//课程出勤确认
import growthCenterEntry from '@/components/growthCenterEntry'//成长中心入口
import skypeIdDialog from '@/components/dialogs/skypId'//skypeIdDialog
import store from '@/store'
import {showContract, userExtInfo, getIsAgreeProtocol, agreeProtocolByTuid, isShowTutorSystemTransferNotice, AddPCClientVersionInfoRecord, isShowDialogList } from '@/api/teachinfo'
import { getCookie } from '@/utils/tools'

export default {
  components: {
    sidebarMenu,
    headers,
    // lessonNoReg,
    noticeModal,
    systemMsgModal,
    rightAlert,
    level,
    chatBox,
    report,
    points,
    covertCash,
    email,
    // teacherPaypalModify,
    bindingPhone,
    enrolment,
    imiframe,
    imLinkUI,
    // lotteryPreheat,
    lessonReminder,
    didiDialog,
    referralShare,
    moodle,
    feedbackDialog,
    appFlow,
    publicClass,
    growthValues,
    tesolDialog,
    clientDownloadDialog,
    christmasDialog,
    courseAttendanceDialog,
    growthCenterEntry,
    skypeIdDialog
  },
  data () {
    return {
      right: true,
      title: 'Vuetify.js',
      timeOut: '',
      refreshDialog: false,
      message1: 'Long time no operation.',
      message2: 'Please refresh the page to view the latest data!',
      reminder: {
        dialog: false,
        progress: 100,
        seconds: 30,
        timer: null,
        timer1: null
      },
      clientDownload: {
        dialog: false,
        sort: 2,
        title: '',
        content: ''
      },
      info: {},
      msg: "",
      skypeIdDialogs:{
        dialog: false
      }
    }
  },
  mounted () {

    window.addEventListener('resize', () => this.setLayoutSize(), false)

    this.setLayoutSize()

    if (this.$store.state.user.isFirstLogin) {
      this.$root.$alert(`             
      We rearranged the website, and realized an integration of some functions.<br>
      （1）The Dashboard page is newly designed. Click Logo jump to this page, and all data the teacher required is displayed there. The Performance Date page is deleted. <br>
      （2）A Function Set is added. The teacher can hide the temporary no-need pages. <br>
      （3）Message function is updated. The pop-ups are reduced greatly.<br>
      （4）The Tutor’s Information is improved. The flower list and personal information can be found here. The teacher can see personal point and point level here, and can also change flowers into cash directly. <br>
      （5）Explore, and you will find more.
      `, 'Update Instruction', { width: '50%' })

    }
      userExtInfo().then(res=>{
        this.info = res.data.Body;
        if(this.info && this.info.IsCustomized === true){
          store.dispatch('internationalOrCustom', 1)
        }
        if (res && this.info.PersonalState == 0 || (this.info.ContactState == 0&&this.info.HB==0) ) {
          if (this.info.HB ==0) {
            if (this.info.TLState == 0) {
              this.msg = `According to the relevant regulatory authorities, tutors who
                   provide online teaching services need to submit complete
                   personal information and the agreement signed with <br>
                  Acadsoc,so as to better protect the rights of both tutors<br>
                   and students.<br>
                  Please complete as soon as possible the personal <br>
                  information,and sign and upload the agreement;<br>
                  if you need help, please contact your DS/TM. `
            }else {
              this.msg = `According to the relevant regulatory authorities, tutors who
                   provide online teaching services need to submit complete
                  personal information, so as to better protect the rights
                   of both tutors and students.<br>
                  Please complete the personal information as soon as 
                  possible; if you need help, please contact your DS/TM. `
            }
          }else {
            this.msg = `According to the relevant regulatory authorities, tutors who
                provide online teaching services need to submit complete
                personal information, so as to better protect the rights
                of both tutors and students.<br>
                Please complete the personal information as soon as 
                possible; if you need help, please contact your DS/TM. `
          }
          this.$root.$alert(this.msg, '', {
            icon: {
              default: true
            },
            cancelBtn: {
              display: false
            },
            confirmBtn: {
              display: true,
              color: "primary darken-1"
            },
            width:500
          }).then((rel) => {
            if (rel) {
              if (this.info.PersonalState == 0&& this.info.ContactState==0) {
                // 个人信息
                this.$router.push('/newPersonalData')
              }else if (this.info.PersonalState == 1 && this.info.ContactState==0 && this.info.HB == 0) {
                // 合同页面
                // showContract().then(res=>{
                //   if (res && res.data.Body.Item3==0) {
                //     this.$router.push({ name: 'signContract' })
                //   }else if (res && res.data.Body.Item3==1) {
                //     this.$router.push({ name: 'signContractCustom' })
                //   }
                // })
              }else if (this.info.PersonalState == 0 && this.info.ContactState==1) {
                // 个人资料
                this.$router.push('/newPersonalData')
              }
            }
          })
        }
      })
    this.isTimeOut()

    getIsAgreeProtocol().then(res => {
      if (res.data.ErrorCode === 0 && !res.data.Body && res.data.Body == false) {
        this.reminder.dialog = true;
        this.countdown()
      }
    })

    // 老师端迁移通知弹窗
    isShowTutorSystemTransferNotice().then(res => {
      if (res.data.ErrorCode === 0 && res.data.Body && res.data.Body.ShowNotice && !(getCookie('client') == 'tutorclient')) {
        this.clientDownload.dialog = true;
        this.clientDownload.title = res.data.Body.Title;
        this.clientDownload.content = res.data.Body.Content
      }
    })
    //课件预加载
    this.PreloadPageUrl()
    //记录客户端版本信息
    this.AddPCClientVersionInfoRecord()

    this.isShowDialogList()
  },
  computed: {
    // 操作和取用同一对象pointsDialog
    pointsData () {
      return this.$store.state.layout.pointsDialog
    },
    levelData () {
      return this.$store.state.layout.levelDialog
    },
    chatBoxData () {
      return this.$store.state.layout.aiDialog
    },
    reportData () {
      console.log(this.$store.state.layout.reportDialog,9999)
      return this.$store.state.layout.reportDialog
    },
    cashData () {
      return this.$store.state.layout.cashDialog
    },
    emailData () {
      return this.$store.state.layout.emailDialog
    },
    enrolmentData () {
      return this.$store.state.layout.enrolmentDialog
    },
    feedbackData () {
      return this.$store.state.layout.feedbackDialog
    },
    showSidebarMenuMini () {
      return this.$store.state.user.sidebarMenuMini
    },
    growthValues () {
      return this.$store.state.layout.growthValuesDialog
    },
    firstLogin: function () {
      return this.$store.state.user.isFirstLogin
    }
  },
  methods: {
    throttle (fn, wait) {
      let timer = null
      let startTime = Date.now()
      return function () {
        let curTime = Date.now()
        let remaining = wait - (curTime - startTime)
        let context = this
        let args = arguments
        clearTimeout(timer)
        if (remaining <= 0) {
          fn.apply(context, args)
          startTime = Date.now()
        } else {
          timer = setTimeout(fn, remaining)
        }
      }
    },
    handle () {
      clearInterval(this.timeOut);
      this.timeOut = setInterval(() => {
        this.refreshDialog = true
      }, 1000 * 60 * 10) //10m

    },
    isTimeOut () {
      document.body.onmouseup = this.throttle(this.handle, 1000)
      document.body.onmousemove = this.throttle(this.handle, 1000)
      document.body.onkeyup = this.throttle(this.handle, 1000)
      document.body.onclick = this.throttle(this.handle, 1000)
      window.addEventListener('resize', this.throttle(this.handle, 1000))
      window.addEventListener('scroll', this.throttle(this.handle, 1000))
    },
    cancel () {
      this.refreshDialog = false
    },
    toRefresh () {
      this.refreshDialog = false
      window.location.reload()
    },
    countdown () {
      this.reminder.seconds = 30;
      this.reminder.progress = 100;
      this.reminder.timer = setInterval(() => {
        this.reminder.seconds--;
        if (this.reminder.seconds == 0) {
          this.reminder.seconds = 0;
          this.reminder.progress = 0;
          clearInterval(this.reminder.timer1)
          clearInterval(this.reminder.timer)
          this.reminder.timer = null;
          this.reminder.timer1 = null
          return
        }
      }, 1000)
      this.reminder.timer1 = setInterval(() => {
        this.reminder.progress -= 100 / 150
      }, 200)
    },
    agreeProtocol () {
      this.reminder.dialog = false
      agreeProtocolByTuid();
    },
    PreloadPageUrl () {
      getAgoraCoursewarePreloadPageUrl()
        .then(res => {
          if (res) {
            window.open(res.PageUrl, 'newwindow', 'height=1,width=1,top=9999,left=0,toolbar=no,menubar=no,scrollbars=no,resizable=no,location=no,status=no')
            // window.open (res.PageUrl, 'newwindow', 'height=100, width=400, top=0, left=0, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=no, status=no')
          } else {

          }
        })
    },
    setLayoutSize () {
      var offsetWid = document.documentElement.clientWidth;
      if (offsetWid < 1400) {
        window.document.documentElement.setAttribute('data-layout', 'small')
      } else {
        window.document.documentElement.setAttribute('data-layout', '')
      }
    },
    AddPCClientVersionInfoRecord(){
      //记录客户端版本信息
      console.info("version:"+window.acVersion);
      if(typeof window.acVersion !== 'undefined' && window.acVersion != null){
        var nowVersion=window.acVersion;
        var tuid=this.$store.state.user.tuid;
        var lastVersionTuid=localStorage.getItem("clientVersion-"+tuid);
        var nowVersionTuid="version:"+nowVersion;
        //判断版本号是否改变,有变动则记录
        if(lastVersionTuid==null || typeof lastVersionTuid == 'undefined' || nowVersionTuid!=lastVersionTuid){
          var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
          var clientName="tutor-"+(isMac?"mac":"window");
          AddPCClientVersionInfoRecord(nowVersion,clientName).then(res=>{
             if (res && res.data && res.data.Msg==="Success"){
                localStorage.setItem("clientVersion-"+tuid,nowVersionTuid);
             }
          })
        }
      }
    },
    isShowDialogList(){
      // 填写skype提示
      isShowDialogList().then(res => {

        if (res.data.ErrorCode == 0 && res.data.Body.data && res.data.Body.data.length > 0) {
          let da = res.data.Body.data
          let d = da.filter(function(item){
              return item.Type == "1"; 
          })
          if(d.length){
            this.skypeIdDialogs.dialog = true
          }else{
            this.skypeIdDialogs.dialog = false
          }
        }else{
          this.skypeIdDialogs.dialog = false
        }
      })
    }
  },

}
</script>
<style lang="scss">
// 全局域？？ 会有影响？？
table.v-table thead th {
  font-size: 14px;
  font-weight: 800;
}
.overall-btns {
  left: 0;
  bottom: 70px;
  position: fixed;
  z-index: 200;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  .side-menu-card {
    z-index: 99;
    width: 37px;
    height: 32px;
    line-height: 32px;
    cursor: pointer;
    margin-bottom: 10px;
    position: relative;
    box-sizing: border-box;
    border-radius: 0px 30px 30px 0px;
    transition: all 0.5s;
    justify-content: space-between;
    display: flex;
    align-items: center;
    padding-right: 3px;
    // overflow: hidden;
    &.feedback {
      border: 1px solid #f69898;
      background: #fef4f4;
      // background: rgba(246, 152, 152, 0.1);
      .feedback-menu {
        background: url(../../assets/img/common/sidemenu/feedback.png) no-repeat
          center;
        width: 26px;
        height: 26px;
      }
    }
    &.class {
      // background: rgba(184, 102, 248, 0.1);
      background: #f8effe;
      border: 1px solid #b866f8;
      .class-menu {
        background: url(../../assets/img/common/sidemenu/class.png) no-repeat
          center;
        width: 26px;
        height: 26px;
      }
    }
    &.share {
      // background: rgba(94, 169, 253, 0.1);
      background: #eff6ff;
      border: 1px solid #55a5ff;
      .share-menu {
        background: url(../../assets/img/common/sidemenu/share.png) no-repeat
          center;
        width: 26px;
        height: 26px;
      }
    }
    &.moodle {
      // background: rgba(255, 172, 62, 0.1);
      background: #fff7eb;
      border: 1px solid #ffac3e;
      .moodle-menu {
        background: url(../../assets/img/common/sidemenu/moodle.png) no-repeat
          center;
        width: 26px;
        height: 26px;
      }
      &:hover {
        width: 37px !important;
        span {
          width: 0;
          opacity: 0;
          padding-left: 0;
        }
        .moodle-menu {
          background: url(../../assets/img/common/sidemenu/moodle.png) no-repeat
            center rgba(255, 172, 62, 0.2);
          border-radius: 30px;
        }
      }
    }
    &.app {
      // background: rgba(62, 102, 251, 0.08);
      background: #f0f3ff;
      border: 1px solid #3e67fb;
      .app-menu {
        background: url(../../assets/img/common/sidemenu/app.png) no-repeat
          center;
        width: 26px;
        height: 26px;
      }
      &:hover {
        width: 37px !important;
        span {
          width: 0;
          opacity: 0;
          padding-left: 0;
        }
        .app-menu {
          background: url(../../assets/img/common/sidemenu/app.png) no-repeat
            center rgba(62, 103, 251, 0.14);
          border-radius: 30px;
        }
      }
    }
    &.public {
      background: #f4fbf2;
      border: 1px solid #98db7c;
      .public-menu {
        background: url(../../assets/img/common/sidemenu/public.png) no-repeat
          center;
        width: 26px;
        height: 26px;
      }
    }
    span {
      width: 0;
      overflow: hidden;
      height: 32px;
      opacity: 0;
      transition: all 0.5s;
      color: $blue-title;
      font-size: 12px;
    }
    &:hover {
      width: 160px;
      span {
        opacity: 1;
        width: auto;
        padding-left: 10px;
      }
      .feedback-menu {
        background: url(../../assets/img/common/sidemenu/feedback.png) no-repeat
          center rgba(246, 152, 152, 0.2);
        border-radius: 30px;
      }
      .class-menu {
        background: url(../../assets/img/common/sidemenu/class.png) no-repeat
          center rgba(184, 102, 248, 0.2);
        border-radius: 30px;
      }
      .share-menu {
        background: url(../../assets/img/common/sidemenu/share.png) no-repeat
          center rgba(94, 169, 253, 0.2);
        border-radius: 30px;
      }
      .public-menu {
        background: url(../../assets/img/common/sidemenu/public.png) no-repeat
          center rgba(152, 219, 124, 0.2);
        border-radius: 30px;
      }
    }
  }
}
.overall-btns-right{
  right: 17px;
  bottom: 70px;
  position: fixed;
  z-index: 199;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.refresh-dialog.custom-dialog .custom-icon .v-icon {
  font-size: 36px;
}
.margin-78 {
  margin-left: 78px;
  max-width: calc(
    100vw - 78px
  ); //转介绍表格数据较多小屏时内容超出屏幕宽度无水平滚动条
}
[data-layout="small"] .margin-78 {
  margin-left: 54px;
  max-width: calc(100vw - 54px);
}
.margin-221 {
  margin-left: 221px;
  max-width: calc(100vw - 221px);
}
.page-content {
  padding-top: 68px;
  display: flex;
}
[data-theme="theme1"] .page-content {
  background: #151827;
}
[data-layout="small"] .page-content {
  padding-top: 50px;
}
.common-content {
  flex: 1;
  min-height: calc(100vh - 68px);
  @include bg_color($background-color-theme);
  min-width: 1200px;
}
[data-layout="small"] .common-content {
  min-width: 975px;
}
</style>
